module.exports = __webpack_public_path__ + "static/sigma-thumbnail-a7a198f1b9a37b5315ee9eacba314fe4.jpeg";